export const getPlanTooltip = (planName: string): string =>
  `This account is currently enjoying complimentary access to a ${planName} plan.`;
